module.exports = __webpack_public_path__ + "img/AboutUs.18156bf1.png";